import "../assets/css/App.css";
import React, { useContext, useEffect } from "react";
import logoST from "../assets/images/LogoSTL.svg";
import logoLolify from "../assets/images/Lilofy_color.png";
import { Card, Grid, Box, Button, TextField, CardContent } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import MuiAlert from "@mui/material/Alert";
import { RootStoreContext } from "../app/store/root";
import { observer } from "mobx-react-lite";
import { Catalogos } from "../app/util/catalogos";
import { account } from "../shared/Utils";
import Alerts from "../shared/Alerts";
import LogisticBackdropStore from "../shared/LogisticBackdrop";
import DialogComponent from "../app/common/DialogComponent";
import { EnumPerfiles } from "../shared/Enumerables";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AuthPage() {
  useEffect(() => {
    document.title = 'Lilofy | Autenticación';
  })
  const rootStore = useContext(RootStoreContext);

  const {
    getInformacionUsuario: _getInformacionUsuario,
  } = rootStore.usuarioStore

  const {
    enviaCodigoAutenticacion: _enviaCodigoAutenticacion,
    validarCodigoAutenticacion: _validarCodigoAutenticacion,
  } = rootStore.authStore;

  const navigate = useNavigate();
  const [codigo, setCodigo] = React.useState(null);
  const [errorCodigo, setErrorCodigo] = React.useState(false);
  const [errorCodigoMsj, setErrorCodigoMsj] = React.useState("");

  const onChangeCodigo = (e) => {
    setCodigo(e.target.value);
  };

  const codigoValidation = () => {
    if (codigo?.length == 6) {
      setErrorCodigo(false);
      setErrorCodigoMsj("");
      return true;
    }
    setErrorCodigo(true);
    setErrorCodigoMsj("El código debe tener una longitud de 6 caracteres.");
    return false;
  };

  const reenviaCodigoAutenticacion = async () => {
    let response = await _enviaCodigoAutenticacion();
    if (response.data) {
      rootStore.alertStore.alertSuccess("Código enviado al correo con éxito.");
    } else {
      rootStore.alertStore.alertError("Error al enviar el código al correo.");
    }
  };

  const validarCodigoAutenticacion = async (e) => {
    if (codigoValidation()) {
      rootStore.logisticBackdropStore.openLoading()
      let response = await _validarCodigoAutenticacion(codigo);
      if (response.data.success) {
        rootStore.alertStore.alertSuccess("Información de inicio de sesión validado correctamente. Redirigiendo a la pantalla de inicio.");
        //save account in storage
        let accountData = await _getInformacionUsuario()
        account.saveDatosUsuario(accountData)
        rootStore.logisticBackdropStore.closeLoading()
        if (accountData?.perfil.toUpperCase() === EnumPerfiles.Proveedor)
          navigate('/Proveedores/Dashboard')
        else if (accountData?.perfil.toUpperCase() === EnumPerfiles.Administrador)
          navigate('/Usuarios/Dashboard')
        else
          navigate('/Usuarios/Home')

      } else {
        rootStore.alertStore.alertError(response.data.mensaje)
        rootStore.logisticBackdropStore.closeLoading()
      }
    }
  };

  const [showConfirmCancel, setShowConfirmCancel] = React.useState(false)

  const cancelarClick = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    event.preventDefault();
    setShowConfirmCancel(true)
  }

  const onAccept = () => {
    navigate("/");
  }
  return (
    <Grid
      container
      direction={"column"}
      justifyContent="center"
      alignItems="center"
    >
      <LogisticBackdropStore />
      <Alerts />
      <Grid item sx={{ textAlign: "center" }}>
        <Box display={"flex"} justifyContent={"center"}>
          <img src={logoLolify} alt="logo" width={"20%"} />
        </Box>
      </Grid>
      <Grid item sx={{ display: "flex" }} justifyContent="center">
        <Card sx={{ width: "50%" }}>
          <CardContent className="card-body">
            <Grid
              container
              direction={"column"}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <h6>
                  <strong>
                    INGRESE EL CÓDIGO DE AUTENTICACIÓN DE DOS FACTORES
                  </strong>
                </h6>
              </Grid>
              <Grid item>
                <p className="textJustify">
                  Para completar su inicio de sesión, ingrese el código de
                  autenticación que se le envió a su correo electrónico.
                </p>
              </Grid>
              <Grid item>
                <Box component="form" noValidate sx={{ mt: 1 }}>
                  <TextField
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    id="codigoAuth"
                    label="Código de autentificación"
                    name="codigoAuth"
                    autoComplete="codigoAuth"
                    onChange={(e) => onChangeCodigo(e)}
                    onBlur={(e) => codigoValidation()}
                    autoFocus
                    inputProps={{ maxLength: 6 }}
                    error={errorCodigo}
                    helperText={errorCodigoMsj}
                    onKeyPress={event => {
                      if (event.key === 'Enter') {
                        event.preventDefault()
                        validarCodigoAutenticacion(event)
                      }
                    }}
                  />
                  <Grid
                    container
                    spacing={2}
                    direction={"row"}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item sm={"auto"}>
                      <Button
                        sx={{ color: "#fff" }}
                        color="secondary"
                        variant="contained"
                        onClick={(e) => reenviaCodigoAutenticacion()}
                      >
                        Reenviar
                      </Button>
                    </Grid>
                    <Grid item sm={"auto"}>
                      <Button
                        variant="contained"
                        onClick={(e) => validarCodigoAutenticacion(e)}
                      >
                        Continuar
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction={"column"}
                    justifyContent="center"
                    alignItems="center"
                    className="mt-3"
                  >
                    <Grid item>

                      <button type="button" className="btn btn-link" onClick={(e) => setShowConfirmCancel(true)} >
                        Cancelar
                      </button>

                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <DialogComponent
        Open={showConfirmCancel}
        Message="Si cierra o cancela esta ventana se perderá la información capturada. ¿Está seguro que desea continuar?"
        OnClose={() => setShowConfirmCancel(false)}
        OnAccept={() => {
          setShowConfirmCancel(false)
          onAccept()
        }}
      />
    </Grid>
  );
}

export default observer(AuthPage);
